query GetUser($id: ID!) {
  user(id: $id) {
    id
    insertedAt
    updatedAt
    name
    first_name
    last_name
    email
    role {
      id
      name
    }
    account {
      id
      name
    }
  }
}
